import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const modules = [{
  title: 'MÓDULO #1: CONTROL MENTAL PASO A PASO',
  desc: 'Recibís instrucciones claras para dominar tu mente.',
  bullets: ['Eliminás la ansiedad', 'Controlás la excitación', 'Evitás perder el control'],
  note: 'Es como tener un "botón interno".',
  num: '01'
}, {
  title: 'MÓDULO #2: TÉCNICAS FÍSICAS EXACTAS',
  desc: 'No más improvisación.',
  bullets: ['Ritmo', 'Pausas', 'Intensidad'],
  note: 'Sabés exactamente qué hacer en cada momento.',
  num: '02'
}, {
  title: 'MÓDULO #3: SISTEMA COMPLETO (A → Z)',
  desc: 'Nada de consejos sueltos.',
  bullets: ['Todo ordenado', 'Paso a paso', 'Aplicable desde el día 1'],
  num: '03'
}, {
  title: 'MÓDULO #4: ENTRENAMIENTO EN CASA',
  desc: 'Ejercicios simples.',
  bullets: ['Más control', 'Más resistencia', 'Más duración'],
  num: '04'
}, {
  title: 'MÓDULO #5: NIVEL PRO',
  desc: 'Acá es donde cambia TODO.',
  bullets: ['Más placer', 'Más conexión', 'Más dominio'],
  num: '05'
}];
export function ModulesSection() {
  return <motion.section initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5
  }} className="py-12 px-4 max-w-4xl mx-auto" data-id="element-94">
      <div className="space-y-8" data-id="element-95">
        {/* Hero banner */}
        <div className="relative rounded-2xl overflow-hidden mb-4" data-id="element-96">
          <img src="https://cdn.magicpatterns.com/uploads/mfUUyzjjBMo6CP3HyDtdBA/ebook_2.jpg" alt="Sistema Completo" className="w-full h-64 md:h-80 object-cover" data-id="element-97" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent flex items-end" data-id="element-98"></div>
        </div>

        {modules.map((mod, idx) => <div key={idx} className="relative bg-gray-900 border border-gray-800 p-8 md:p-10 rounded-2xl hover:border-brand-red transition-colors shadow-lg overflow-hidden" data-id="element-99">
            <span className="absolute top-4 right-6 text-6xl font-heading text-gray-800/30 font-bold select-none" data-id="element-100">
              {mod.num}
            </span>
            <div className="relative z-10" data-id="element-101">
              <h3 className="text-2xl md:text-3xl font-heading text-brand-red uppercase mb-4 pr-16" data-id="element-102">
                🔥 {mod.title}
              </h3>
              <p className="text-gray-300 text-lg mb-6" data-id="element-103">{mod.desc}</p>
              <div className="flex flex-wrap gap-4 mb-6" data-id="element-104">
                {mod.bullets.map((bullet, i) => <span key={i} className="bg-gray-800 text-white px-4 py-2 rounded-full text-sm md:text-base font-medium flex items-center border border-gray-700" data-id="element-105">
                    <span className="text-brand-gold mr-2" data-id="element-106">👉</span> {bullet}
                  </span>)}
              </div>
              {mod.note && <p className="text-gray-400 italic text-lg" data-id="element-107">{mod.note}</p>}
            </div>
          </div>)}
      </div>

      <div className="mt-20 bg-gray-900 border border-brand-green/30 p-10 rounded-2xl text-center shadow-[0_0_20px_rgba(22,163,74,0.1)]" data-id="element-108">
        <h3 className="text-3xl font-heading text-white uppercase mb-8" data-id="element-109">
          📊 RESULTADOS:
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-110">
          <div className="flex flex-col items-center" data-id="element-111">
            <span className="text-brand-green text-3xl mb-3" data-id="element-112">✔️</span>
            <span className="text-white font-bold text-lg" data-id="element-113">Más duración</span>
          </div>
          <div className="flex flex-col items-center" data-id="element-114">
            <span className="text-brand-green text-3xl mb-3" data-id="element-115">✔️</span>
            <span className="text-white font-bold text-lg" data-id="element-116">Más control</span>
          </div>
          <div className="flex flex-col items-center" data-id="element-117">
            <span className="text-brand-green text-3xl mb-3" data-id="element-118">✔️</span>
            <span className="text-white font-bold text-lg" data-id="element-119">Más confianza</span>
          </div>
          <div className="flex flex-col items-center" data-id="element-120">
            <span className="text-brand-green text-3xl mb-3" data-id="element-121">✔️</span>
            <span className="text-white font-bold text-lg" data-id="element-122">
              Mejor rendimiento
            </span>
          </div>
        </div>
      </div>

      <div className="mt-16 text-center max-w-2xl mx-auto" data-id="element-123">
        <h2 className="text-3xl font-heading text-white uppercase mb-6" data-id="element-124">
          🧠 TAN CLARO… QUE TU CUERPO RESPONDE SOLO
        </h2>
        <p className="text-gray-300 text-xl mb-6" data-id="element-125">Cuando aplicás esto…</p>
        <div className="flex flex-col md:flex-row justify-center gap-6 text-white font-bold text-lg" data-id="element-126">
          <span data-id="element-127">👉 Todo empieza a "encajar"</span>
          <span data-id="element-128">👉 Deja de ser confuso</span>
          <span data-id="element-129">👉 Se vuelve natural</span>
        </div>
      </div>

      <div className="mt-20 bg-gray-900 border border-gray-800 p-10 rounded-2xl max-w-3xl mx-auto shadow-xl" data-id="element-130">
        <h3 className="text-3xl font-heading text-white uppercase mb-8 text-center" data-id="element-131">
          📦 TODO LO QUE VAS A RECIBIR
        </h3>
        <ul className="space-y-5 text-gray-200 font-medium text-lg mb-10" data-id="element-132">
          <li className="flex items-center" data-id="element-133">
            <CheckCircleIcon className="text-brand-green mr-4 w-6 h-6 flex-shrink-0" data-id="element-134" />{' '}
            Sistema completo paso a paso
          </li>
          <li className="flex items-center" data-id="element-135">
            <CheckCircleIcon className="text-brand-green mr-4 w-6 h-6 flex-shrink-0" data-id="element-136" />{' '}
            Técnicas mentales y físicas
          </li>
          <li className="flex items-center" data-id="element-137">
            <CheckCircleIcon className="text-brand-green mr-4 w-6 h-6 flex-shrink-0" data-id="element-138" />{' '}
            Entrenamiento progresivo
          </li>
          <li className="flex items-center" data-id="element-139">
            <CheckCircleIcon className="text-brand-green mr-4 w-6 h-6 flex-shrink-0" data-id="element-140" />{' '}
            Acceso desde cualquier dispositivo
          </li>
          <li className="flex items-center" data-id="element-141">
            <CheckCircleIcon className="text-brand-green mr-4 w-6 h-6 flex-shrink-0" data-id="element-142" />{' '}
            Aplicación inmediata
          </li>
        </ul>

        <div className="flex flex-col items-center justify-center space-y-3 pt-6 border-t border-gray-800" data-id="element-143">
          <a href="[CART_LINK]" className="inline-block w-full md:w-auto text-center bg-brand-red hover:bg-brand-redHover text-white font-heading text-2xl py-5 px-10 rounded-xl transition-all transform hover:scale-[1.02] shadow-[0_0_25px_rgba(220,38,38,0.3)]" data-id="element-144">
            EMPEZAR AHORA →
          </a>
          <p className="text-sm text-gray-400 font-medium" data-id="element-145">
            ✔️ Garantía de 30 días — Sin riesgo
          </p>
        </div>
      </div>
    </motion.section>;
}